// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import translate from "@insite/client-framework/Translate";
import { getVmiLocations } from "@vanmeter/App/Services/VmiLocationsService";
import { XVmiLocationModel } from "@vanmeter/App/Store/Reducers";

type Parameter = HasOnSuccess & HasOnError<string>;

type Props = {
    apiResult?: XVmiLocationModel[];
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginLoadVmiLocations: HandlerType = props => {
    props.dispatch({
        type: "xVmiLocations/SetLoading",
        isLoading: true,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getVmiLocations();
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.dispatch({
            type: "xVmiLocations/SetLoading",
            isLoading: false,
        });
        props.parameter.onError?.(result?.errorMessage || translate("Something went wrong while loading locations."));
        return false;
    }
};

export const DispatchCompleteLoadVmiLocations: HandlerType = props => {
    props.dispatch({
        type: "xVmiLocations/CompleteLoad",
        locations: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.();
    }
};

export const chain = [
    DispatchBeginLoadVmiLocations,
    RequestDataFromApi,
    DispatchCompleteLoadVmiLocations,
    ExecuteOnSuccessCallback,
];

const loadVmiLocations = createHandlerChainRunner(chain, "loadVmiLocations");
export default loadVmiLocations;
